module.exports = __webpack_public_path__ + "img/Feature.eba2c5f3.jpg";